import { useState, useEffect, useMemo } from "react";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import PhotoGalleryEnv from "./PhotoGalleryEnv";
import VideoGalleryEnv from "./VideoGalleryEnv";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { getLatestDateFromData } from "../../../Utils/utils";
import EnvironmentPageTabs from "./EnvironmentPageTabs";
import ReportsEnv from "./ReportsEnv";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const EnvironmentPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: environmentData = [], isLoading: environmentDataIsLoading } =
    useGetProtectedApiDataQuery({ url: "environment", lang: languageType });

  // last updated on
  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(environmentData);
  }, [environmentData]);

  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (environmentData.length > 0) {
      const lastElement = environmentData[environmentData.length - 1];
      setActiveTab(lastElement.title);
    }
  }, [environmentData, languageType]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (environmentDataIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Sustainable Development", "सतत विकास")}
        titleLink="/sustainable-development/environment"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    {environmentData
                      .slice()
                      .reverse()
                      .map((item, index) => (
                        <li key={index} className="nav-item">
                          <a
                            href="#"
                            className={`nav-link ${
                              activeTab === item.title ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(item.title);
                            }}
                          >
                            {item.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div
                className="col-12 col-sm-12 col-md-9 col-lg-9 print-right"
                tabIndex={0}
              >
                {environmentData?.map((item, index) => {
                  if (activeTab === item.title) {
                    switch (item.title) {
                      case "Environmental Reports":
                      case "पर्यावरणीय रिपोर्ट":
                        return <ReportsEnv key={index} data={item} />;
                      case "Photo Gallery":
                      case "फोटो गैलरी":
                        return <PhotoGalleryEnv key={index} data={item} />;
                      case "Video Gallery":
                      case "वीडियो गैलरी":
                        return <VideoGalleryEnv key={index} data={item} />;
                      default:
                        return (
                          <EnvironmentPageTabs
                            key={index}
                            data={item}
                            title={item.title}
                          />
                        );
                    }
                  }
                  return null;
                })}
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default EnvironmentPage;
